import { render, staticRenderFns } from "./CardVotantesRepetidos.vue?vue&type=template&id=23d1a49e&scoped=true"
import script from "./CardVotantesRepetidos.vue?vue&type=script&lang=js"
export * from "./CardVotantesRepetidos.vue?vue&type=script&lang=js"
import style0 from "./CardVotantesRepetidos.vue?vue&type=style&index=0&id=23d1a49e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d1a49e",
  null
  
)

export default component.exports